<template>
  <div class="smsConfiguration-container" v-loading="pageLoading">
    <!-- 平台配置 -->
    <div class="title-style">
      <el-divider class="left-divider"></el-divider>
      <div class="center-text">— {{ $t('bike.name534') }} —</div>
      <el-divider class="right-divider"></el-divider>
    </div>
    <el-form
      ref="platformFormRef"
      :model="platformConfig"
      :rules="platformRules"
      :label-width="formLabelWidth('xl')"
      class="platform-form"
      size="medium"
    >
      <el-form-item :label="$t('bike.name536')" prop="smsPlatformCode">
        <el-select v-model="platformConfig.smsPlatformCode" :placeholder="$t('public.name1')" style="width: 320px;">
          <el-option
            v-for="item in platformOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('bike.name548')" prop="accessKeyId">
        <el-input v-model="platformConfig.accessKeyId" :placeholder="$t('public.name5')" style="width: 320px;" clearable />
      </el-form-item>
      <el-form-item :label="$t('bike.name549')" prop="accessKeySecret">
        <el-input
          v-model="platformConfig.accessKeySecret"
          :placeholder="$t('public.name5')"
          style="width: 320px;"
          clearable
        />
      </el-form-item>
      <el-form-item :label="$t('bike.name538')" prop="smsMaxCount">
        <el-input-number v-model="platformConfig.smsMaxCount" :min="1" :max="999999" />
        <span class="unit-text">{{ $t('bike.name539') }}</span>
      </el-form-item>

      <el-form-item :label="$t('bike.name537')" prop="smsRegion">
        <el-input v-model="platformConfig.smsRegion" :placeholder="$t('public.name5')" style="width: 320px;" clearable />
      </el-form-item>
    </el-form>

    <!-- 模板管理 -->
    <div class="template-header">
      <div class="title-style template-title">
        <el-divider class="left-divider"></el-divider>
        <div class="center-text">— {{ $t('bike.name535') }} —</div>
        <el-divider class="right-divider"></el-divider>
      </div>
      <el-button type="text" class="add-template-btn" @click="openTemplateDialog()" v-if="canEdit">
        [+ {{ $t('bike.name540') }}]
      </el-button>
    </div>
    <el-table
      :data="templateList"
      :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }"
      class="template-table"
      @row-dblclick="row => canEdit && openTemplateDialog(templateList.indexOf(row))"
    >
      <el-table-column :label="$t('bike.name541')" prop="businessCode" min-width="120" />
      <el-table-column :label="$t('bike.name542')" prop="templateId" min-width="140" />
      <el-table-column :label="$t('bike.name543')" prop="templateContext" min-width="280" show-overflow-tooltip />
      <el-table-column :label="$t('bike.name544')" width="100" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#0f73e6"
            inactive-color="#dcdfe6"
            :disabled="!canEdit"
          />
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name15')" width="200" align="center" v-if="canEdit">
        <template slot-scope="scope">
          <el-button type="text" @click="openTemplateDialog(scope.$index)">{{ $t('manage.name17') }}</el-button>
          <el-button type="text" @click="openTestDialog(scope.row)">{{ $t('bike.name545') }}</el-button>
          <el-button type="text" style="color:#ea4646" @click="removeTemplate(scope.$index)">{{ $t('manage.name18') }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 底部操作 -->
    <div class="footer-actions" v-if="canEdit">
      <el-button type="primary" :loading="saveLoading" @click="saveConfiguration">{{ $t('bike.name546') }}</el-button>
    </div>

    <!-- 新增/编辑模板 -->
    <AppDialog
      width="560px"
      extra-class="template-dialog"
      :title="templateDialogIndex === -1 ? $t('bike.name540') : $t('bike.name550')"
      :visible.sync="templateDialogVisible"
      @closed="resetTemplateForm"
    >
      <el-form ref="templateFormRef" :model="templateForm" :rules="templateRules" :label-width="formLabelWidth('md')" size="medium">
        <el-form-item :label="$t('bike.name541')" prop="businessCode">
          <el-select
            v-model="templateForm.businessCode"
            :placeholder="$t('public.name1')"
            style="width: 100%;"
            @change="onBusinessCodeChange"
          >
            <el-option
              v-for="item in businessCodeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('bike.name542')" prop="templateId">
          <el-input v-model="templateForm.templateId" :placeholder="$t('public.name5')" clearable />
        </el-form-item>
        <el-form-item :label="$t('bike.name556')" prop="templateName">
          <el-input v-model="templateForm.templateName" :placeholder="$t('public.name5')" clearable />
        </el-form-item>
        <el-form-item :label="$t('bike.name557')" prop="signId">
          <el-input v-model="templateForm.signId" :placeholder="$t('public.name5')" clearable />
        </el-form-item>
        <el-form-item :label="$t('bike.name558')" prop="signName">
          <el-input v-model="templateForm.signName" :placeholder="$t('public.name5')" clearable />
        </el-form-item>
        <el-form-item :label="$t('bike.name563')" prop="paramCount">
        <el-input-number v-model="templateForm.paramCount" :min="1" :max="999999" />
      </el-form-item>
          <el-form-item :label="$t('bike.name543')" class="preset-content-item" prop="templateContext">
            <el-input
              v-model="templateForm.templateContext"
              type="textarea"
              :rows="3"
              :placeholder="$t('public.name5')"
              clearable
            />
          </el-form-item>
          <el-form-item :label="$t('bike.name559')">
          <el-radio-group v-model="templateForm.status">
            <el-radio :label="true">{{ $t('bike.name560') }}</el-radio>
            <el-radio :label="false">{{ $t('bike.name562') }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="template-dialog-footer">
        <el-button type="primary" @click="confirmTemplate">{{ $t('public.name25') }}</el-button>
        <el-button @click="templateDialogVisible = false">{{ $t('public.name14') }}</el-button>
      </span>
    </AppDialog>

    <!-- 测试发送 -->
    <AppDialog
      width="480px"
      extra-class="test-dialog"
      :title="$t('bike.name545')"
      :visible.sync="testDialogVisible"
      @closed="resetTestForm"
    >
      <el-form ref="testFormRef" :model="testForm" :rules="testRules" :label-width="formLabelWidth('sm')" size="medium">
        <el-form-item :label="$t('bike.name551')" prop="inputPhone">
          <el-input v-model="testForm.inputPhone" :placeholder="$t('public.name5')" clearable />
        </el-form-item>
        <el-form-item
          v-for="(param, index) in testForm.paramList"
          :key="'param-' + index"
          :label="index === 0 ? $t('bike.name565') : ''"
          :rules="paramItemRules"
        >
          <div class="param-row">
            <el-input
              v-model="testForm.paramList[index]"
              :placeholder="$t('bike.name565') + (index + 1)"
              clearable
            />
            <el-button
              v-if="index === testForm.paramList.length - 1"
              type="text"
              icon="el-icon-plus"
              class="add-param-btn"
              @click="addTestParam"
            >{{ $t('bike.name566') }}</el-button>
            <el-button
              v-if="testForm.paramList.length > 1"
              type="text"
              icon="el-icon-minus"
              class="remove-param-btn"
              @click="removeTestParam(index)"
            />
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="template-dialog-footer">
        <el-button type="primary" :loading="testLoading" @click="submitTestSend">{{ $t('bike.name552') }}</el-button>
        <el-button @click="testDialogVisible = false">{{ $t('public.name14') }}</el-button>
      </span>
    </AppDialog>
  </div>
</template>
<script>
import { getPlatformListApi, getConfigApi, getBusinessListApi, editConfigApi, smsSendTestApi } from '@/api/manage.js'
import AppDialog from '@/components/AppDialog/index.vue'

export default {
  components: { AppDialog },
  data() {
    return {
      buttonPerms: '',
      tenantId: '',
      canEdit: false,
      pageLoading: false,
      saveLoading: false,
      testLoading: false,
      platformConfig: {
        tenantId: '',
        smsPlatformCode: '',
        smsRegion: '',
        accessKeyId: '',
        accessKeySecret: '',
        smsMaxCount: 30,
        smsTemplateList: [],
      },
      platformRules: {
        smsPlatformCode: [{ required: true, message: this.$t('public.name1'), trigger: 'change' }],
        accessKeyId: [{ required: true, message: this.$t('public.name5'), trigger: 'blur' }],
        accessKeySecret: [{ required: true, message: this.$t('public.name5'), trigger: 'blur' }],
        smsMaxCount: [{ required: true, message: this.$t('public.name5'), trigger: 'change' }]
      },
      platformOptionsList: [],
      platformOptions: [],
      templateList: [],
      businessCodeOptions: [],
      businessCodeOptionsList: [],
      templateDialogVisible: false,
      templateDialogIndex: -1,
      templateForm: {
        id: '',
        businessCode: '',
        templateId: '',
        templateName: '',
        signId: '',
        signName: '',
        paramCount: 1,
        templateContext: '',
        status: true
      },
      templateRules: {
        businessCode: [{ required: true, message: this.$t('public.name1'), trigger: 'change' }],
        templateId: [{ required: true, message: this.$t('public.name5'), trigger: 'blur' }],
        templateName: [{ required: true, message: this.$t('public.name5'), trigger: 'blur' }],
        signName: [{ required: true, message: this.$t('public.name5'), trigger: 'blur' }],
        templateContext: [{ required: true, message: this.$t('public.name5'), trigger: 'blur' }],
        paramCount: [{ required: true, message: this.$t('public.name5'), trigger: 'blur' }],
      },
      testDialogVisible: false,
      testTemplateRow: null,
      testForm: {
        smsPlatformCode: '',
        accessKeyId: '',
        accessKeySecret: '',
        smsRegion: '',
        businessCode: '',
        templateId: '',
        templateName: '',
        signId: '',
        signName: '',
        paramCount: '',
        templateContext: '',
        phone: '',
        inputPhone: '',
        paramList: ['']
      },
      testRules: {
        inputPhone: [
          { required: true, message: this.$t('public.name5'), trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: this.$t('public.name27'), trigger: 'blur' }
        ]
      },
      paramItemRules: [
        { required: true, message: this.$t('public.name5'), trigger: 'blur' }
      ]
    }
  },
  created() {
    this.tenantId = this.$route.query.tenantId
    this.buttonPerms = localStorage.getItem('buttonPerms') || ''
    this.canEdit = this.buttonPerms.indexOf('tenant/configuration') > -1
    if (this.canEdit) {
      this.getConfig()
      this.getPlatformList()
      this.getBusinessList()
    }
    this.platformConfig.tenantId = this.tenantId
    // this.loadConfig()
  },
  beforeDestroy() {
    this.$bus.$off('lang')
  },
  mounted () {
    this.$bus.$on('lang', (lang) => {
      this.platformOptions = []
      let obj = {}
      this.platformOptionsList.map((item) => {
        if (lang === 'en') {
          obj = {
            label: item.enName,
            value: item.code
          }
          this.platformOptions.push(obj)
        } else {
          obj = {
            label: item.cnName,
            value: item.code
          }
          this.platformOptions.push(obj)
        }
      })
      this.buildBusinessCodeOptions(lang)
    })
  },
  methods: {
    buildBusinessCodeOptions(lang) {
      this.businessCodeOptions = []
      const isEn = lang === 'en'
      this.businessCodeOptionsList.forEach((item) => {
        this.businessCodeOptions.push({
          label: isEn ? item.enName : item.cnName,
          value: item.code
        })
      })
    },
    getPresetContentByCode(code) {
      if (!code) {
        return ''
      }
      const item = this.businessCodeOptionsList.find(i => i.code === code)
      if (!item) {
        return ''
      }
      return item.templateContent || item.presetContent || item.content || ''
    },
    onBusinessCodeChange(code) {
      if (this.templateDialogIndex === -1) {
        this.templateForm.templateContext = this.getPresetContentByCode(code)
      }
    },
    getBusinessList() {
      getBusinessListApi()
        .then(res => {
          if (res.code === 200 && res.data) {
            this.businessCodeOptionsList = res.data
            this.buildBusinessCodeOptions(localStorage.getItem('lang'))
          }
        })
        .catch(() => { })
    },
    getConfig () {
      getConfigApi({ tenantId: this.tenantId })
        .then(res => {
          if (res.code === 200 && res.data) {
            this.platformConfig = {
              tenantId: this.tenantId,
              smsPlatformCode: res.data.smsPlatformCode,
              smsRegion: res.data.smsRegion,
              accessKeyId: res.data.accessKeyId,
              accessKeySecret: res.data.accessKeySecret,
              smsMaxCount: res.data.smsMaxCount,
              smsTemplateList: res.data.smsConfigList
            }
            this.templateList = res.data.smsConfigList
          }
        })
        .catch(() => { })
    },
    getPlatformList () {
      this.platformOptions = []
      getPlatformListApi()
        .then(res => {
          if (res.code === 200 && res.data) {
            this.platformOptionsList = res.data
            const lang = localStorage.getItem('lang')
            let obj = {}
            res.data.map((item) => {
              if (lang === 'en') {
                obj = {
                  label: item.enName,
                  value: item.code
                }
                this.platformOptions.push(obj)
              } else {
                obj = {
                  label: item.cnName,
                  value: item.code
                }
                this.platformOptions.push(obj)
              }
            })
          }
        })
        .catch(() => { })
    },
    loadConfig() {
      if (!this.tenantId) {
        return
      }
      this.pageLoading = true
    },
    openTemplateDialog(index = -1) {
      this.templateDialogIndex = index
      if (index > -1) {
        const row = this.templateList[index]
        this.templateForm = {
          id: row.id || '',
          businessCode: row.businessCode || '',
          templateId: row.templateId || '',
          templateName: row.templateName || '',
          signId: row.signId || '',
          signName: row.signName || '',
          paramCount: row.paramCount != null ? row.paramCount : 1,
          templateContext: row.templateContext || '',
          status: row.status !== false
        }
      } else {
        this.templateForm = {
          id: '',
          businessCode: '',
          templateId: '',
          templateName: '',
          signId: '',
          signName: '',
          paramCount: 1,
          templateContext: '',
          status: true
        }
      }
      this.templateDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.templateFormRef) {
          this.$refs.templateFormRef.clearValidate()
        }
      })
    },
    resetTemplateForm() {
      this.templateDialogIndex = -1
      this.templateForm = {
        id: '',
        businessCode: '',
        templateId: '',
        templateName: '',
        signId: '',
        signName: '',
        paramCount: 1,
        templateContext: '',
        status: true
      }
    },
    confirmTemplate() {
      this.$refs.templateFormRef.validate(valid => {
        if (!valid) {
          return
        }
        const item = {
          ...this.templateForm,
        }
        if (this.templateDialogIndex > -1) {
          this.$set(this.templateList, this.templateDialogIndex, item)
        } else {
          this.templateList.push(item)
        }
        this.templateDialogVisible = false
      })
    },
    removeTemplate(index) {
      this.$confirm(this.$t('bike.name564'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          this.templateList.splice(index, 1)
        })
        .catch(() => {})
    },
    saveConfiguration() {
      this.$refs.platformFormRef.validate(valid => {
        if (!valid) {
          return
        }
        if (this.templateList.length === 0) {
          this.$message({ type: 'warning', message: this.$t('bike.name540') })
          return
        }
        this.saveLoading = true
        this.platformConfig.smsTemplateList = this.templateList
        editConfigApi(this.platformConfig)
          .then(res => {
            if (res.code === 200) {
              this.$message({ type: 'success', message: this.$t('public.name18') })
              // this.loadConfig()
            }
          })
          .catch(() => {})
          .finally(() => {
            this.saveLoading = false
          })
      })
    },
    openTestDialog(row) {
      if (!row || !row.templateId) {
        this.$message({ type: 'warning', message: this.$t('bike.name553') })
        return
      }
      this.$refs.platformFormRef.validate(valid => {
        if (!valid) {
          this.$message({ type: 'warning', message: this.$t('bike.name567') })
          return
        }
        this.testTemplateRow = row
        this.testForm = {
          smsPlatformCode: this.platformConfig.smsPlatformCode,
          accessKeyId: this.platformConfig.accessKeyId,
          accessKeySecret: this.platformConfig.accessKeySecret,
          smsRegion: this.platformConfig.smsRegion,
          businessCode: row.businessCode,
          templateId: row.templateId,
          templateName: row.templateName,
          signId: row.signId,
          signName: row.signName,
          paramCount: row.paramCount,
          templateContext: row.templateContext,
          phone: '',
          inputPhone: '',
          paramList: ['']
        }
        this.testDialogVisible = true
        this.$nextTick(() => {
          if (this.$refs.testFormRef) {
            this.$refs.testFormRef.clearValidate()
          }
        })
      })
    },
    addTestParam() {
      this.testForm.paramList.push('')
    },
    removeTestParam(index) {
      this.testForm.paramList.splice(index, 1)
    },
    resetTestForm() {
      this.testTemplateRow = null
      this.testForm.phone = ''
      this.testForm.paramList = []
    },
    submitTestSend() {
      this.$refs.testFormRef.validate(valid => {
        if (!valid) {
          return
        }
        this.testLoading = true
        this.testForm.phone = 'CN-86-' + this.testForm.inputPhone
        smsSendTestApi(this.testForm)
          .then(res => {
            if (res.code === 200) {
              this.$message({ type: 'success', message: this.$t('public.name17') })
              this.testDialogVisible = false
            }
          })
          .catch(() => {})
          .finally(() => {
            this.testLoading = false
          })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.smsConfiguration-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 24px 40px;
  box-sizing: border-box;

  .title-style {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;

    .left-divider {
      width: 20%;
    }

    .center-text {
      width: 160px;
      text-align: center;
      font-size: 15px;
      color: #333;
      white-space: nowrap;
    }

    .right-divider {
      flex: 1;
    }
  }

  .platform-form {
    max-width: 560px;
    margin-bottom: 32px;

    .unit-text {
      margin-left: 8px;
      color: #606266;
    }
  }

  .template-header {
    display: flex;
    align-items: center;
    margin-bottom: 12px;

    .template-title {
      flex: 1;
      margin-bottom: 0;
    }

    .add-template-btn {
      font-size: 14px;
      padding: 0 8px;
      white-space: nowrap;
    }
  }

  .template-table {
    width: 100%;

    .delete-icon {
      font-size: 22px;
      color: #ea4646;
      cursor: pointer;

      &:hover {
        color: #c93030;
      }
    }
  }

  .footer-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 32px;
    gap: 12px;
  }
}

.preset-section {
  margin-top: 8px;

  .preset-title {
    margin-bottom: 16px;

    .left-divider {
      width: 15%;
    }

    .center-text {
      width: auto;
      min-width: 180px;
      font-size: 14px;
      color: #909399;
      padding: 0 8px;
    }

    .right-divider {
      flex: 1;
    }
  }

  .preset-content-item {
    margin-bottom: 0;

    .preset-text {
      line-height: 1.6;
      color: #606266;
      padding: 8px 12px;
      background: #f5f7fa;
      border-radius: 4px;
      min-height: 40px;
      word-break: break-all;
    }
  }
}
</style>
<style lang="scss">
.template-dialog,
.test-dialog {
  .template-dialog-footer {
    display: flex;
    justify-content: center;
    gap: 16px;
  }
}

.test-dialog {
  .param-row {
    display: flex;
    align-items: center;
    gap: 8px;

    .el-input {
      flex: 1;
    }

    .add-param-btn,
    .remove-param-btn {
      flex-shrink: 0;
      padding: 0 4px;
    }
  }
}
</style>
